import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "chain-select-options"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "label"
};
import { supportedChainListInfo } from '@/service/chains-config';
import { useUserStore } from '@/store/user';
import { useWalletConnectStore } from '@/store/wallet-connect';
export default /*#__PURE__*/_defineComponent({
  __name: 'up-select-chain',
  emits: ["change"],

  setup(__props, {
    emit: $emit
  }) {
    const userStore = useUserStore();

    const onChainChanged = v => {
      const chainId = Number(v);
      userStore.updateChainId(chainId); // wallet connect

      const walletConnectStore = useWalletConnectStore();
      walletConnectStore.onChainChanged(chainId);
      $emit('change', chainId);
    };

    return (_ctx, _cache) => {
      const _component_up_icon = _resolveComponent("up-icon");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(supportedChainListInfo), e => {
        return _openBlock(), _createElementBlock("div", {
          key: e.label,
          class: "option",
          onClick: $event => onChainChanged(e.value)
        }, [_createVNode(_component_up_icon, {
          width: "24",
          height: "24",
          name: e.label
        }, null, 8, ["name"]), _createElementVNode("div", _hoisted_3, _toDisplayString(e.label), 1), e.value === String(_unref(userStore).chainId) ? (_openBlock(), _createBlock(_component_up_icon, {
          key: 0,
          class: "round-select",
          name: "round-select"
        })) : _createCommentVNode("", true)], 8, _hoisted_2);
      }), 128))]);
    };
  }

});